import { apiCall } from './gqlClient';

const MEALTEMPLATES_QUERY = `
  query mealTemplates($providerId: Float, $mealType: String, $search: String, $limit: JSON!) {
    mealTemplates(providerId: $providerId, mealType: $mealType, search: $search, limit: $limit)
    {
      id
			providerId
			name
			mealType
			description
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			imageId
			imageUrl
			coverUrl
			isPublic
			dateCreated
      ...fragments
    }
  }`;

export const mealTemplatesApiCall = async ({providerId, mealType, search, limit}, fragments = null) => apiCall({ query: MEALTEMPLATES_QUERY, variables: {providerId, mealType, search, limit}, fragments });

const MEALTEMPLATE_QUERY = `
  query mealTemplate($id: String!) {
    mealTemplate(id: $id)
    {
      id
			providerId
			name
			mealType
			description
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			imageId
			imageUrl
			coverUrl
			isPublic
			dateCreated
      ...fragments
    }
  }`;

export const mealTemplateApiCall = async ({id}, fragments = null) => apiCall({ query: MEALTEMPLATE_QUERY, variables: {id}, fragments });

const MEALTEMPLATEITEMS_QUERY = `
  query mealTemplateItems($mealTemplateId: String!) {
    mealTemplateItems(mealTemplateId: $mealTemplateId)
    {
      id
			mealTemplateId
			ingredientId
			recipeId
			quantityG
			itemOrder
			note
      ...fragments
    }
  }`;

export const mealTemplateItemsApiCall = async ({mealTemplateId}, fragments = null) => apiCall({ query: MEALTEMPLATEITEMS_QUERY, variables: {mealTemplateId}, fragments });

const CREATEMEALTEMPLATE_QUERY = `
  mutation createMealTemplate($input: MealTemplateInput!) {
    createMealTemplate(input: $input)
    {
      id
			providerId
			name
			mealType
			description
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			imageId
			imageUrl
			coverUrl
			isPublic
			dateCreated
      ...fragments
    }
  }`;

export const createMealTemplateApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEMEALTEMPLATE_QUERY, variables: {input}, fragments });

const UPDATEMEALTEMPLATE_QUERY = `
  mutation updateMealTemplate($id: String!, $input: MealTemplateInput!) {
    updateMealTemplate(id: $id, input: $input)
    {
      id
			providerId
			name
			mealType
			description
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			imageId
			imageUrl
			coverUrl
			isPublic
			dateCreated
      ...fragments
    }
  }`;

export const updateMealTemplateApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEMEALTEMPLATE_QUERY, variables: {id, input}, fragments });

const DELETEMEALTEMPLATE_QUERY = `
  mutation deleteMealTemplate($id: String!) {
    deleteMealTemplate(id: $id)
    {
      id
			providerId
			name
			mealType
			description
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			imageId
			imageUrl
			coverUrl
			isPublic
			dateCreated
      ...fragments
    }
  }`;

export const deleteMealTemplateApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEMEALTEMPLATE_QUERY, variables: {id}, fragments });

const CREATEMEALTEMPLATEITEM_QUERY = `
  mutation createMealTemplateItem($input: MealTemplateItemInput!) {
    createMealTemplateItem(input: $input)
    {
      id
			mealTemplateId
			ingredientId
			recipeId
			quantityG
			itemOrder
			note
      ...fragments
    }
  }`;

export const createMealTemplateItemApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEMEALTEMPLATEITEM_QUERY, variables: {input}, fragments });

const DELETEMEALTEMPLATEITEM_QUERY = `
  mutation deleteMealTemplateItem($id: String!) {
    deleteMealTemplateItem(id: $id)
    {
      id
			mealTemplateId
			ingredientId
			recipeId
			quantityG
			itemOrder
			note
      ...fragments
    }
  }`;

export const deleteMealTemplateItemApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEMEALTEMPLATEITEM_QUERY, variables: {id}, fragments });
